// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1r8YK","title":"styles_title__27T92"};